function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - ContactNumber component
 * 
 */

import * as React from 'react';
import { connect } from 'react-redux';
import Select from '../select/Select';
import TextInput from '../text-input/TextInput';
import ErrorMessage from '../error-message/ErrorMessage';
import { phoneCountryCode, phoneNumber } from '../../actions';
import { PHONE_COUNTRY_CODE } from '../../data/Data';
import './ContactNumber.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class ContactNumber extends React.Component {
  render() {
    const {
      contacts,
      float,
      name,
      section,
      setPhoneCountryCode,
      setPhoneNumber
    } = this.props;
    const {
      error
    } = contacts.contactNumber ? contacts.contactNumber : {
      error: false
    };
    const classes = `form-element-container ${name}${error ? ' error' : ''}${float ? ' left' : ''}`;
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "field-set",
        children: [/*#__PURE__*/_jsx(Select, {
          autoComplete: "tel-area-code",
          label: 'Country code *',
          options: PHONE_COUNTRY_CODE,
          name: 'phoneCountryCode',
          section: section,
          handleChange: setPhoneCountryCode,
          onBlur: setPhoneCountryCode,
          values: contacts
        }), /*#__PURE__*/_jsx(TextInput, {
          autoComplete: "tel",
          label: 'Contact number *',
          name: 'phoneNumber',
          placeholder: 'eg 0400123456 / 0299223344',
          section: section,
          handleChange: setPhoneNumber,
          onBlur: setPhoneNumber,
          values: contacts,
          type: "tel",
          inputMode: "numeric"
        })]
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        message: 'You must enter a contact number',
        error: error
      })]
    });
  }
}
_defineProperty(ContactNumber, "defaultProps", {
  contacts: {
    phoneCountryCode: {
      error: false,
      required: true,
      valid: null,
      value: '61'
    },
    contactNumber: {
      error: false,
      required: true,
      valid: null,
      value: ''
    },
    phoneNumber: {
      error: false,
      required: true,
      valid: null,
      value: ''
    }
  },
  float: false,
  id: 'select',
  label: 'select',
  name: 'contactNumber',
  required: false,
  section: 'personal-details'
});
const mapStateToProps = ({
  contacts
}) => {
  return {
    contacts
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setPhoneCountryCode: value => {
      dispatch(phoneCountryCode(value));
    },
    setPhoneNumber: value => {
      dispatch(phoneNumber(value));
    }
  };
};
const VisibleContactNumber = connect(mapStateToProps, mapDispatchToProps)(ContactNumber);
export default VisibleContactNumber;